import type {
    FishGroup,
    FishGroupCurrentLocation,
    FishGroupCurrentLocationDto,
    FishGroupDetail,
    FishGroupDetailDto,
    FishGroupDto,
} from '../types';

import { asFishGroupStatus } from './enumGuards';

// ---------------------------------------------------------------------------
// Detail
// ---------------------------------------------------------------------------

export function mapFishGroupDetailToDomain(dto: FishGroupDetailDto): FishGroupDetail {
    return {
        ...mapFishGroupBaseToDomain(dto),
        currentLocation: dto.currentLocation
            ? mapCurrentLocationToDomain(dto.currentLocation)
            : null,
    };
}

export function mapFishGroupBaseToDomain(dto: FishGroupDto | FishGroupDetailDto): FishGroup {
    return {
        id: dto.id,
        name: dto.name,
        status: asFishGroupStatus(dto.status),
        clientId: dto.clientId,
        fishTypeId: dto.fishTypeId,
        initialPopulationSize: dto.initialPopulationSize ?? null,
        lifecycleStartedAt: dto.lifecycleStartedAt ?? null,
        lifecycleEndedAt: dto.lifecycleEndedAt ?? null,
        notes: dto.notes ?? null,
    };
}

function mapCurrentLocationToDomain(dto: FishGroupCurrentLocationDto): FishGroupCurrentLocation {
    return {
        locationRowId: dto.locationRowId,
        cageId: dto.cageId,
        cageName: dto.cageName,
        locationId: dto.locationId,
        locationName: dto.locationName,
        fromDate: dto.fromDate,
    };
}
